import React, { Component } from "react";
import "./Testimonials.css";
import { TestimonialsItem } from "./TestimonialsItem";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import { getImgUrl, limitText } from "../../Utility/Utility";
import { TestimonialsData } from "../../Data/Data";

class Testimonials extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.TestimonialsSliderSettings = {
      dots: false,
      infinite: true,
      cssEase: "linear",
      autoplay: false,
      lazyLoad: "ondemand",
      arrows: false,
      slidesToShow: this.props.items != undefined ? this.props.items : 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    };
  }

  render() {
    const data = [...TestimonialsData];
    const postsHtml = data.map((o, i) => {
      // console.log('o:', o);
      return (
        <TestimonialsItem
          desc={o.desc}
          imgVideo={o.imgVideo}
          vidId={o.vidId}
          id={i}
          key={i}
          country={o.country}
          name={o.name}
        />
      );
    });
    return (
      <div className="testimonials-wrapper">
        {/*<SimpleSlider settings={this.TestimonialsSliderSettings}>{postsHtml}</SimpleSlider>*/}

        {postsHtml}
      </div>
    );
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/Components/Testimonials/Testimonials.js